import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTheme, useMediaQuery, Box } from "@mui/material";
import api from 'state/axios';
import FriendListWidget from "scenes/widgets/FriendListWidget";
import MyPostWidget from "scenes/widgets/MyPostWidget";
import PostsWidget from "scenes/widgets/PostsWidget";
import UserWidget from "scenes/widgets/UserWidget";


const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const { userId } = useParams();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  
  useEffect(() => {
    const getUser = async () => {
      const response = await api.get(`/users/${userId}`);      
      setUser(response.data);
    };

    getUser();
  }, [userId]); 

  if (!user) return null;

  return (
    <Box>
      <Box
        width="100%"
        padding="1rem"
        display={isDesktop ? "flex" : "block"}
        justifyContent="center"
        gap={1}
      >
        <Box flexBasis={isDesktop ? "26%" : undefined}>
          <UserWidget userId={userId} picturePath={user.picturePath} />
          <Box m="2rem 0" />
          <FriendListWidget userId={userId} />
        </Box>
        <Box
          flexBasis={isDesktop ? "67%" : undefined}
          mt={isDesktop ? undefined : "2rem"}
        >
          <MyPostWidget picturePath={user.picturePath} />
          <Box m="2rem 0" />
          <PostsWidget userId={userId} isProfile />
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage;
